import { useEffect, useState } from 'react';
import { StripePaymentElementChangeEvent } from '@stripe/stripe-js';
import { useElements } from '@stripe/react-stripe-js';

export const useStripePaymentMethodType = (onChange?: (type: string | null) => void) => {
  const [paymentMethodType, setPaymentMethodType] = useState<string>(null);
  const elements = useElements();

  useEffect(() => {
    if (!elements) return;

    const paymentElement = elements.getElement('payment');

    if (!paymentElement) return;

    const handleChange = (event: StripePaymentElementChangeEvent) => {
			const newValue = event?.value?.type ?? null;

      setPaymentMethodType((prev) => {
				if (prev === newValue) return prev;

				onChange?.(newValue);

				return newValue;
			});
    };

    paymentElement.on('change', handleChange);

    return () => {
      paymentElement.off('change', handleChange);
    };
  }, [elements, onChange]);

  return paymentMethodType;
};
